import React, { useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  FlatList,
} from "react-native";
import { Octicons } from "@expo/vector-icons";
import { FontAwesome } from "@expo/vector-icons";
import { timeformet } from "../../component/format";
import { timeCalulate } from "../../component/utils";
const { width, height } = Dimensions.get("window");
export default function tebleuserrank({ navigation, data, setCurrentName, onOrderPress, currentPage, totalPages, onPrevPage, onNextPage }) {
  const [orderBy, setOrderBy] = React.useState(null);

  function handleOrderBy() {
    let newOrderBy = null;
    if (orderBy === null) {
      newOrderBy = 'name:asc';
    } else if (orderBy === 'name:asc') {
      newOrderBy = 'name:desc';
    } else {
      newOrderBy = null;
    }
    setOrderBy(newOrderBy);
    if (onOrderPress) {
      onOrderPress(newOrderBy);
    }
  }

  return (
    <View style={styles.back}>
      <View style={styles.head}>
        <TouchableOpacity onPress={handleOrderBy} style={[styles.viewhead, { width: width * 0.22 }]}>
          <Text style={[styles.texthead, { alignSelf: "center" }]}>User</Text>
        </TouchableOpacity>
        <View
          style={[
            styles.viewhead,
            { width: width * 0.22, justifyContent: "center" },
          ]}
        >
          <Text style={[styles.texthead, { alignSelf: "center" }]}>Email</Text>
        </View>
        <View style={[styles.viewhead, { width: width * 0.13 }]}>
          <Text style={styles.texthead}>Role</Text>
        </View>
        <View style={[styles.viewhead, { width: width * 0.13 }]}>
          <Text style={styles.texthead}>Distance</Text>
        </View>
        <View style={[styles.viewhead, { width: width * 0.13 }]}>
          <Text style={styles.texthead}>Time</Text>
        </View>
      </View>

      <FlatList
        data={data}
        scrollEnabled
        ListFooterComponent={
          <View style={styles.pagination}>
            <TouchableOpacity
              onPress={onPrevPage}
              disabled={currentPage <= 1}
              style={[styles.pageBtn, currentPage <= 1 && styles.pageBtnDisabled]}
            >
              <Text style={styles.pageBtnText}>{'< Prev'}</Text>
            </TouchableOpacity>
            <Text style={styles.pageInfo}>{currentPage} / {totalPages}</Text>
            <TouchableOpacity
              onPress={onNextPage}
              disabled={currentPage >= totalPages}
              style={[styles.pageBtn, currentPage >= totalPages && styles.pageBtnDisabled]}
            >
              <Text style={styles.pageBtnText}>{'Next >'}</Text>
            </TouchableOpacity>
          </View>
        }
        renderItem={({ index, item }) => {
          return (
            <View>
              {item.user_accounts != undefined && (
                <View style={[styles.viewmain, { backgroundColor: "#fff" }]}>
                  <TouchableOpacity
                    onPress={() =>
                      setCurrentName(item.user_accounts?.name ?? item.user_accounts?.username)
                    }
                    style={[styles.viewdetail, { width: width * 0.22 }]}
                  >
                    <Image
                      source={{
                        uri:

                          item.user_accounts.image_Profile,
                      }}
                      style={styles.img}
                    />
                    <View style={{ flexDirection: "row", width: width * 0.13, overflow: 'hidden', }}>
                      <Text style={styles.textdeil}>
                        {item.runningNumber}
                      </Text>
                      {item.user_accounts.name == "" ||
                        item.user_accounts.name == null ? (
                        <Text style={styles.textdeil} numberOfLines={1}>
                          {item.user_accounts.username}
                        </Text>
                      ) : (
                        <Text style={styles.textdeil} numberOfLines={1}>
                          {item.user_accounts.name}
                        </Text>
                      )}
                    </View>
                  </TouchableOpacity>
                  <View style={[styles.viewdetail, { width: width * 0.22 }]}>
                    <Text
                      style={[styles.textdate, { alignSelf: "flex-start" }]}
                      numberOfLines={1}
                    >
                      {item.user_accounts.email}
                    </Text>
                  </View>
                  <View style={[styles.viewdetail, { width: width * 0.13 }]}>
                    <Text style={styles.textdate}>
                      {item.user_accounts.role}
                    </Text>
                  </View>
                  <View style={[styles.viewdetail, { width: width * 0.13 }]}>
                    <Text style={styles.textdate}>
                      {(item.last_distance / 1000).toFixed(3)} KM
                    </Text>
                  </View>
                  <View style={[styles.viewdetail, { width: width * 0.13 }]}>
                    <Text style={styles.textdate}>
                      {timeCalulate(item.running_Time)}
                    </Text>
                  </View>
                </View>
              )}
            </View>
          );
        }}
      />
    </View>
  );
}
const styles = StyleSheet.create({
  back: {
    width: width * 0.85,
    height: "82%",
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
  },
  head: {
    width: width * 0.828,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
  },
  viewhead: {
    paddingLeft: 10,
  },
  texthead: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
  },
  viewdetail: {
    flexDirection: "row",
  },
  img: {
    width: 39,
    height: 39,
    marginTop: 5,
  },
  textdeil: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#393939",
    marginTop: 5,
    marginLeft: 15,
  },
  textdetail: {
    fontFamily: "Prompt-Regular",
    fontSize: 12,
    color: "#393939",
    marginLeft: 15,
  },
  viewmain: {
    flexDirection: "row",
    width: width * 0.828,
    height: 50,
    paddingHorizontal: 5,
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewatc: {
    width: width * 0.18,
    height: 30,
    justifyContent: "space-between",
    alignSelf: "flex-end",
    marginBottom: 20,
    flexDirection: "row",
    marginRight: 20,
  },
  touchatc: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    justifyContent: "center",
  },
  textatc: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    color: "#7764E4",
    alignSelf: "center",
  },
  pagination: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 12,
    gap: 16,
  },
  pageBtn: {
    paddingHorizontal: 16,
    paddingVertical: 6,
    backgroundColor: "#7764E4",
    borderRadius: 6,
  },
  pageBtnDisabled: {
    backgroundColor: "#C0C0C0",
  },
  pageBtnText: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#fff",
  },
  pageInfo: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    color: "#172B4D",
    minWidth: 60,
    textAlign: "center",
  },
});
